module.exports = __webpack_public_path__ + "static/media/ic_feature_photo_empty.d995cbec.svg";